import PageWrapper from 'enrollment-platform/PageWrapper'
import useFeatureFlags from 'hooks/useFeatureFlags'
import React, { useEffect } from 'react'
import { browserHistory } from 'react-router'

export default function CustomerOnboardingGate({
  children,
}: {
  children: React.ReactNode
}) {
  const { flags } = useFeatureFlags()
  const isEnabled = flags['admin.new-customer-onboarding-enabled']

  useEffect(() => {
    if (!isEnabled) {
      browserHistory.replace('/not-found')
    }
  }, [isEnabled])

  if (!isEnabled) {
    return null
  }

  return <PageWrapper>{children}</PageWrapper>
}
